import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const courseRowDefaultVariants = {}
const courseRowCompoundVariants = []

const courseRowSlotNames = [
  [
    "root",
    "courseRow__root"
  ],
  [
    "title",
    "courseRow__title"
  ],
  [
    "contentWrapper",
    "courseRow__contentWrapper"
  ],
  [
    "descriptionWrapper",
    "courseRow__descriptionWrapper"
  ],
  [
    "label",
    "courseRow__label"
  ]
]
const courseRowSlotFns = /* @__PURE__ */ courseRowSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, courseRowDefaultVariants, getSlotCompoundVariant(courseRowCompoundVariants, slotName))])

const courseRowFn = memo((props = {}) => {
  return Object.fromEntries(courseRowSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const courseRowVariantKeys = []
const getVariantProps = (variants) => ({ ...courseRowDefaultVariants, ...compact(variants) })

export const courseRow = /* @__PURE__ */ Object.assign(courseRowFn, {
  __recipe__: false,
  __name__: 'courseRow',
  raw: (props) => props,
  variantKeys: courseRowVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, courseRowVariantKeys)
  },
  getVariantProps
})